import { createSlice } from "@reduxjs/toolkit";
import { FetchStatus } from "../../shared/redux.consts";
import {
  TermsAndConditionsState,
  TermsAndConditionsStore,
} from "../../types/compliance-terms-and-conditions";
import {
  fetchCreateComplianceSummary,
  fetchGetComplianceSummary,
  fetchUpdateComplianceSummary,
} from "./compliance-terms-and-conditions.thunk";

const initialTermsAndConditionsState: TermsAndConditionsState = {
  createStatus: FetchStatus.IDLE,
  getStatus: FetchStatus.IDLE,
  updateStatus: FetchStatus.IDLE,
  wisrCustomerId: "",
  recordFound: false,
  customerCompliant: false,
};

export const termsAndConditionsSlice = createSlice({
  name: "termsAndConditions",
  initialState: initialTermsAndConditionsState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchGetComplianceSummary.pending, (state) => {
        state.getStatus = FetchStatus.LOADING;
        state.createStatus = FetchStatus.IDLE;
        state.updateStatus = FetchStatus.IDLE;
        state.getError = undefined;
        state.createError = undefined;
        state.updateError = undefined;
      })
      .addCase(fetchGetComplianceSummary.fulfilled, (state, action) => {
        state.getStatus = FetchStatus.SUCCESS;
        state.wisrCustomerId = action.payload.wisrCustomerId;
        state.recordFound = action.payload.recordFound;
        state.customerCompliant = action.payload.customerCompliant;
      })
      .addCase(fetchGetComplianceSummary.rejected, (state, action) => {
        state.getStatus = FetchStatus.FAILED;
        if (action.error?.message !== undefined) {
          state.getError = action.error.message;
        }
      })
      .addCase(fetchCreateComplianceSummary.pending, (state) => {
        state.createStatus = FetchStatus.LOADING;
        state.getError = undefined;
        state.createError = undefined;
        state.updateError = undefined;
      })
      .addCase(fetchCreateComplianceSummary.fulfilled, (state, action) => {
        state.createStatus = FetchStatus.SUCCESS;
        state.wisrCustomerId = action.payload.wisrCustomerId;
        state.recordFound = action.payload.recordFound;
        state.customerCompliant = action.payload.customerCompliant;
      })
      .addCase(fetchCreateComplianceSummary.rejected, (state, action) => {
        state.createStatus = FetchStatus.FAILED;
        if (action.error?.message !== undefined) {
          state.createError = action.error.message;
        }
      })
      .addCase(fetchUpdateComplianceSummary.pending, (state) => {
        state.updateStatus = FetchStatus.LOADING;
        state.getError = undefined;
        state.createError = undefined;
        state.updateError = undefined;
      })
      .addCase(fetchUpdateComplianceSummary.fulfilled, (state, action) => {
        state.updateStatus = FetchStatus.SUCCESS;
        state.wisrCustomerId = action.payload.wisrCustomerId;
        state.recordFound = action.payload.recordFound;
        state.customerCompliant = action.payload.customerCompliant;
      })
      .addCase(fetchUpdateComplianceSummary.rejected, (state, action) => {
        state.updateStatus = FetchStatus.FAILED;
        if (action.error?.message !== undefined) {
          state.updateError = action.error.message;
        }
      });
  },
});

export const selectTermsAndConditionsState = (store: TermsAndConditionsStore) =>
  store.termsAndConditionsState;

export default termsAndConditionsSlice.reducer;
